import React from 'react'

import { Dialog, Table, Text } from '@plurall/elo-beta'

interface IStudentLinkedResponsible {
  cells: Array<{
    id: number
    value: string
  }>
  id: string
  menu: []
}

interface IResponsibleLinkStudentConfirmationModalProps {
  onClose: () => void
  onConfirm: () => void
  onCancel: () => void
  students: IStudentLinkedResponsible[]
  isLoading: boolean
}

const ResponsibleLinkStudentConfirmationModal = ({
  onConfirm,
  onClose,
  onCancel,
  students,
  isLoading,
}: IResponsibleLinkStudentConfirmationModalProps) => {
  const tableHeader = [
    {
      id: 1,
      value: 'N°',
    },
    {
      id: 2,
      value: 'Aluno',
      width: 300,
    },
  ]

  return (
    <Dialog
      title={'Vincular aluno'}
      onClose={onClose}
      dataTestId={'responsible-link-student-confirmation-modal'}
      primaryButtonText={'Vincular'}
      closePrimaryClick={false}
      clickOutside={false}
      onPrimaryClick={onConfirm}
      primaryButtonLoading={isLoading}
      secondaryButtonText={'Cancelar'}
      onSecondaryClick={onCancel}
      secondaryButtonDisabled={isLoading}
    >
      <Text size='t2' dataTestId={'responsible-link-student-confirmation-modal-text'}>
        Você está se vinculando a:
      </Text>
      <Table
        headers={tableHeader}
        data={students}
        dataTestId={'responsible-link-student-confirmation-modal-table'}
        ellipsis
      />
    </Dialog>
  )
}

export default ResponsibleLinkStudentConfirmationModal
